import { Component, OnInit, ViewChild } from '@angular/core';
import BaseComponent from '../BaseComponent';
import { SaveTypes } from 'app/models/enums/SaveTypes';
import Utils from '../../../shared/utils';
import System from 'framework/System';
import { LocalProfileInitializationComponent as SharedLocalProfileInitializationComponent } from '../../shared/local-profiles/local-profile-initialization/local-profile-initialization.component';

@Component({
  selector: 'app-components-ticket-localprofileinitialization',
  templateUrl: './local-profile-initialization.component.html',
})
export class LocalProfileInitializationComponent extends BaseComponent implements OnInit {
  @ViewChild(SharedLocalProfileInitializationComponent) localProfileInitializationComponent: SharedLocalProfileInitializationComponent;
  isOpen = false;
  customerJs: Boo.Objects.Customer;

  ngOnInit(): void {
    this.customerJs = ko.mapping.toJS(this.customer);
  }

  save(saveType: SaveTypes): JQueryPromise<app.ticket.interfaces.ISaveData | void> {
    return super.save(saveType)
      .then(() => Utils.wrapDfd(this.localProfileInitializationComponent.save()))
      .then(() => Utils.wrapDfd(this.localProfileInitializationComponent.load()))
      .then(() => System.emptyPromise());
  }
}
